import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import jwt_decode from "jwt-decode"
import { DatePipe, Location} from '@angular/common';
import * as XLSX from 'xlsx';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public loader: BehaviorSubject<any> = new BehaviorSubject(false);
  public showToast: BehaviorSubject<any> = new BehaviorSubject('');
  public isRefreshRequired: BehaviorSubject<any> = new BehaviorSubject(false);
  public backURL: BehaviorSubject<any> = new BehaviorSubject('/contact-list');
  public loaderCount: number = 0;
  private UserReminderVisibilitySource = new Subject<boolean>();
  UserReminderVisibility$ = this.UserReminderVisibilitySource.asObservable();

  private AllReminderVisibilitySource = new Subject<boolean>();
  AllReminderVisibility$ = this.AllReminderVisibilitySource.asObservable();

  private changeEmail = new Subject<string>();
  changeEmailValue = this.changeEmail.asObservable();

  private unreadTaskCountReload = new Subject<void>();
  unreadTaskCountReloadObs = this.unreadTaskCountReload.asObservable();

  private contractingNewStatusCount = new Subject<void>();
  updateContractingNewStatusCountObs = this.contractingNewStatusCount.asObservable();


  private IssueAndFeedbackVisibilitySource = new Subject<boolean>();
  IssueAndFeedbackVisibility$ = this.IssueAndFeedbackVisibilitySource.asObservable();

  constructor(private datePipe: DatePipe, private location: Location) {}
  public sharedRequestData: BehaviorSubject<any> = new BehaviorSubject(true);
  public refreshActivityData: BehaviorSubject<any> = new BehaviorSubject(true);

  // shared data comopnent to component
  public sharedObj(data: any) { //the component that wants to update something, calls this fn
    this.sharedRequestData.next(data); //next() will feed the value in Subject
  }

    public refreshActivity(data: any=null) { 
    this.refreshActivityData.next(data); 
  }
  private tabChangeSource = new Subject<string>();
  tabChange$ = this.tabChangeSource.asObservable();

  changeTab(index: string) {
    this.tabChangeSource.next(index);
  }

  setUserReminderVisibility(isVisible: boolean) {
    this.UserReminderVisibilitySource.next(isVisible);
  }

  setAllReminderVisibility(isVisible: boolean) {
    this.AllReminderVisibilitySource.next(isVisible);
  }

  updateUnreadTaskCount() {
    this.unreadTaskCountReload.next();
  }

  
  updateContractingNewStatusCount() {
    this.contractingNewStatusCount.next();
  }

  updateEmail(email: string){
    this.changeEmail.next(email);
  }
  
  setIssueAndFeedbackVisibility(isVisible: boolean) {
    this.IssueAndFeedbackVisibilitySource.next(isVisible);
  }

  showLoader() {    
    if (this.loaderCount < 0) {
      this.loaderCount = 0;
    }
    this.loaderCount++;
    this.loader.next(true);
  }

  showToastMessage(message){
    this.showToast.next(message);
  }

  hideLoader() {
    this.loaderCount--;
    if (this.loaderCount <= 0) {
      this.loader.next(false);
    }
  }
  public setValue(Key: string, value: any) {
    localStorage[Key] = value;
  }
  public getValue(Key: string) {
    return localStorage[Key];
  }

  getObjectFromToken() {
    return jwt_decode(localStorage.getItem('token'))
  }

  getKey(keyName): any {
    let loggedInUser = this.getObjectFromToken() as any;
    if (loggedInUser) {
      return loggedInUser[keyName];
      //return Array.isArray(loggedInUser[keyName] == false) ? loggedInUser[keyName] : loggedInUser[keyName][0];
    }
    return null;
  }

  public sendUpdate(isDataUpdated: boolean) { //the component that wants to update something, calls this fn
    this.isRefreshRequired.next(isDataUpdated); //next() will feed the value in Subject
  }

  public getUpdate(): Observable<boolean> { //the receiver component calls this function 
    return this.isRefreshRequired.asObservable(); //it returns as an observable to which the receiver funtion will subscribe
  }

  convertUTCTimeToLocalTime(UTCDateString) {
    if (UTCDateString != undefined && UTCDateString != null) {
      var utcTime = new Date(UTCDateString);
      return new Date(utcTime.getTime() - (utcTime.getTimezoneOffset() * 60000));
    }
    else {
      return UTCDateString;
    }
  }

    //Calculate Date difference in days
    calculateDiff(expiryDate) {
      let currentDate = new Date();
      let eDate = new Date(expiryDate);
  
      let days = Math.ceil((eDate.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
      
      return {
        date: days == 0 ? "Today" : days > 0 && days <= 30 ? "In " +  days + ` Day${days > 1 ?'s': ''}` : this.datePipe.transform(expiryDate, 'MM/dd/yyyy'),
        className: days < 0 && expiryDate != null ? "over-due": days < 16 && days >=0 ? "red" : days < 31 && days > 15 ? "orange" : ""
      }
    }

    calculate90DaysDiff(expiryDate) {
      let currentDate = new Date();
      let eDate = new Date(expiryDate);
  
      let days = Math.ceil((eDate.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
      
      return {
        date: days == 0 ? "Today" : days > 0 && days <= 90 ? "In " +  days + ` Day${days > 1 ?'s': ''}` : this.datePipe.transform(expiryDate, 'MM/dd/yyyy'),
        className: days < 0 && expiryDate != null ? "over-due": days < 31 && days >=0 ? "red" : days < 91 && days > 30 ? "orange" : ""
      }
    }

    getBackURL(url){
      this.backURL.next(url);
    }

    exportToExcel(data, columnOrder, sheetName, reportTitle = null, tabName:string = 'data') {
      const workBook = XLSX.utils.book_new();
      var workSheet = XLSX.utils.json_to_sheet([]);

      if(reportTitle){
        XLSX.utils.sheet_add_aoa(workSheet, reportTitle.title, { origin: 'A1' });
      
        XLSX.utils.sheet_add_json(workSheet, data, { origin: reportTitle.dataStartRow, skipHeader: false, header: columnOrder.header });
      }
      else{
        workSheet = XLSX.utils.json_to_sheet(data, columnOrder);
      }

      XLSX.utils.book_append_sheet(workBook, workSheet, tabName);

      XLSX.writeFile(workBook, sheetName);
    }

    generateExcelFromJson(data: any[], fileName: string = 'Data.xlsx') {
      const worksheet = XLSX.utils.json_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Package Details');

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      const blob = new Blob(
        [excelBuffer],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      );

      const file = new File(
        [blob],
        fileName,
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      )

      return file;
    }

    numberOnly(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }

    alphaOnly(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      //added && charCode !== 32 to allow space
      if (charCode > 31 && charCode !== 32 && (charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
        return false;
      }
      return true;
    }

    getMinDate(){
      return {day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() - 100}
    }

    getMaxDate(){
      return { day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear()}
    }

    public getCookie(name: string): string | null {
      const cookies = document.cookie.split('; ');
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    }
  
    public setCookie(name: string, value: string, days: number) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }

    public stopPropagation(event){
      event.stopPropagation();
    }

    formatToDate(date)
    {
      return date.year.toString() + '/' + date.month.toString() + '/' + date.day.toString()
   }

   setDateToNGBDatepickerFormat(date) {
    if (date) {
      var fetchedDate = new Date(date);
      return {
        year: fetchedDate.getFullYear(),
        month: fetchedDate.getMonth() + 1,
        day: fetchedDate.getDate()
      };
    } else {
      return date;
    }
  }

 convertDateToString(dateStruct){
  // const date = new Date(
  //   dateStruct.year,
  //   dateStruct.month - 1,
  //   dateStruct.day
  // );

  // const isoDate = date.toISOString();
  // return isoDate

  const date = dateStruct as NgbDateStruct;

const formattedDate =
  `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}T18:30:00.000`;

  return formattedDate;

}

  FormatBytes = (bytes: number) => {
    const units = ['b', 'kb', 'mb', 'gb', 'tb'];
    let i = 0;
    for (i; bytes >= 1024 && i < 4; i++) {
      bytes /= 1024;
    }
    return `${bytes.toFixed(2)} ${units[i]}`;
  };

  clearCurrentState() {
    const currentUrl = this.location.path();
    this.location.replaceState(currentUrl, '', {});
  }

  toPascalCase(value: string): string {
    return value
      .replace(/[_-]+/g, ' ')
      .split(' ')
      .filter(Boolean)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  isStopDOITransactionsForTenant(tenantId: number) {
    //BroadStreet Partners tenantId = 93
    const stopDOITransactionsForTenantId = 93;
    return tenantId === stopDOITransactionsForTenantId;
  }
}
